import type { PlaybookAsset } from '@carboncopyco/types';
import { InputTextField, TextBase, TextCaption } from '@carboncopyco/ui';
import { usePlayAnalytics } from '@carboncopyco/utils';
import { useEffect } from 'react';
import { SPEAKER_NOTES_MAX_LENGTH } from '../../../consts';
import { useGiveADemo } from '../GiveADemoContext';

const playEntityToIdKey: Record<PlaybookAsset['assetType'], string> = {
  demo: 'demoId',
  tour: 'tourId',
  externalUrl: 'externalUrlId',
};

type SpeakerNotesTabProps = {
  entityId: string;
  entityType: PlaybookAsset['assetType'];
};

export const SpeakerNotesTab = ({
  entityId,
  entityType,
}: SpeakerNotesTabProps) => {
  const { playSource } = useGiveADemo();
  const { trackPlayOpenAssetNotes } = usePlayAnalytics(
    'give_a_demo_modal_customize_modal'
  );

  useEffect(() => {
    trackPlayOpenAssetNotes({
      [playEntityToIdKey[entityType]]: entityId,
      playSource,
    });
  }, [trackPlayOpenAssetNotes, entityId, entityType, playSource]);

  return (
    <div className="px-8 py-7 flex flex-col min-h-full">
      <div className="mb-1.5">
        <TextBase
          label="Add notes to speaker panel"
          color="text-ds-natural-600"
        />
      </div>
      <div className="mb-6">
        <TextCaption
          label="Be demo-ready with notes that only you can see. Please note that you must use the desktop app to see them."
          tagName="p"
        />
      </div>
      <div className="mt-auto">
        <InputTextField
          multiline
          name={`speakerNotes[${entityId}]`}
          inputSize="sm"
          placeholder="Be prepared for the meeting by adding notes here that only you can see."
          multilineOptions={{
            height: 'lg',
            isExpandableHeight: false,
          }}
          noAddedHeight
          showCharsCounter
          maxLength={SPEAKER_NOTES_MAX_LENGTH}
        />
      </div>
    </div>
  );
};
